import { render, staticRenderFns } from "./TwPlPdf.vue?vue&type=template&id=66cafd58&scoped=true&"
import script from "./TwPlPdf.vue?vue&type=script&lang=js&"
export * from "./TwPlPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cafd58",
  null
  
)

export default component.exports